// --------------------------------------------------------
// ITEM LIST - ItemList
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React from 'react'
import { CompanyListContainer, CompanyListItemContainer} 
from '../../pages/company/CompanyList.styled'
import { GeneralContainer, Text } from '../UI/generalLayout/Layout.styled';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import ListHeadersSmallTable from './ListHeadersSmallTable';
import { ListContainer } from './itemListSmallTable.style';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ITEM LIST INTERFACE
// --------------------------------------------------------

interface IItemList{
    list: any[];
    listHeader: any[];
    children: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ItemList = ({list, listHeader, children}:IItemList) => {
  // --------------------------------------------------------
  // ITEM LIST PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo()

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
        {!isMobile && <ListHeadersSmallTable fields={listHeader} />}
        <ListContainer>
            {list.length > 0?  (
            <CompanyListItemContainer>
                {children}
            </CompanyListItemContainer>)
            :(
            <GeneralContainer>
                <Text>Nenhum resultado encontrado</Text>
            </GeneralContainer>
            )}
        </ListContainer>
    </>
  )
  // --------------------------------------------------------
}

export default ItemList